module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "product-donate-type-wrapper"
  }, [_c('div', {
    staticClass: "product-donate-type"
  }, [_c('div', {
    staticClass: "donate-type-item"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "name": "donate_type",
      "value": "onetime"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "onetime")
    },
    on: {
      "change": function($event) {
        _vm.type = "onetime"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label label--left onetime"
  }, [_vm._v("บริจาคครั้งเดียว")])])]), _vm._v(" "), (_vm.recurringEnabled) ? _c('div', {
    staticClass: "donate-type-item"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "name": "donate_type",
      "value": "monthly"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "monthly")
    },
    on: {
      "change": function($event) {
        _vm.type = "monthly"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label label--right monthly"
  }, [_vm._v("บริจาคเป็นรายเดือน")])])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-059760e7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDonateType.vue
// module id = 1101
// module chunks = 0